export class StateController {
    state = 'UNINITIALIZED';
    stateListeners = new Set();
    getState() {
        return this.state;
    }
    subscribeState(listener) {
        this.stateListeners.add(listener);
        listener(this.state);
        return () => {
            this.stateListeners.delete(listener);
        };
    }
    setState(newState) {
        this.state = newState;
        this.stateListeners.forEach(listener => listener(newState));
    }
}
//# sourceMappingURL=StateController.js.map